import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'paragraph-button',
})
export default class ParagraphButton extends IconButton {
}
